<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="infoBlockTitle" class="p-4 rounded bg-beige-500 md:p-6">
    <h4 class="font-bold text-primary-900">{{ infoBlockTitle }}</h4>
    <div
      v-if="infoBlockText"
      class="body-text"
      v-html="richTextToHtmlString(infoBlockText.json, infoBlockText.links)"
    />
  </div>
</template>

<script setup lang="ts">
import gql from '@/gql/contentful';

type Props = {
  id: string;
};

const props = defineProps<Props>();
const { fetchEntryWithGraphQL } = useContentful();

const { data } = await useAsyncData(props.id, async () => {
  const { data, error } = await fetchEntryWithGraphQL(gql.getInfoBlock, {
    id: props.id,
  });
  if (error) {
    return { data: null, error };
  }
  return { data, error: null };
});

const infoBlockTitle = computed(() => (data.value as any).data.infoBlock.infoBlockTitle);

const infoBlockText = computed(() => {
  return (data.value as any).data.infoBlock.infoBlockText;
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'InfoBlock',
});
</script>
